const DEFAULT_PAGE_SIZE = 25;
const MAX_PAGE_SIZE = 500;

export function buildUserListQuery({
  page = 0,
  pageSize = DEFAULT_PAGE_SIZE,
  nomeOuLogin,
  idPerfil,
} = {}) {
  const params = new URLSearchParams();

  params.set("page", String(Math.max(0, Number(page) || 0)));

  const resolvedPageSize = Number(pageSize) || DEFAULT_PAGE_SIZE;
  params.set(
    "pageSize",
    String(Math.min(Math.max(1, resolvedPageSize), MAX_PAGE_SIZE)),
  );

  const search = (nomeOuLogin || "").trim();
  if (search) {
    params.set("nomeOuLogin", search);
  }

  const profileIds = Array.isArray(idPerfil)
    ? idPerfil.filter(Boolean).join(",")
    : (idPerfil || "").trim();

  if (profileIds) {
    params.set("idPerfil", profileIds);
  }

  return `?${params.toString()}`;
}
